export default class SdsHelper {
    static async openSds(sds_id) {
        const url = Electro.SDS_API_URL;

        if (!sds_id || !url) {
            alert('Product SDS not configured.');
            return;
        }

        const wnd = window.open();
        let errorStr = '';

        try {
            const response = await fetch(`${url}?product=${sds_id}&country[]=Canada&country[]=United+States`);
            const json = await response.json();
            if (json[0].pdf_url) {
                wnd.location = json[0].pdf_url;
            } else {
                errorStr = `Could not find SDS for this product. ERR 1-${sds_id}`;
            }
        } catch (error) {
            console.error('Failed to get SDS', error);
            errorStr = `Error getting SDS for this product. ERR 2-${sds_id}`;
        }

        if (errorStr) {
            wnd.close();
            alert(errorStr);
        }
    }
}
